export const SELECT_STATE = 'SELECT_STATE';
export const SELECT_COUNTY = 'SELECT_COUNTY';
export const SELECT_FIELD = 'SELECT_FIELD';
export const SELECT_YEAR = 'SELECT_YEAR';
export const SELECT_PAGE = 'SELECT_PAGE';

export const PAGE_TRANSITION_START = 'PAGE_TRANSITION_START';
export const PAGE_TRANSITION_END = 'PAGE_TRANSITION_END';

export const GET_NATIONAL_AVG_DATA = 'GET_NATIONAL_AVG_DATA';
export const NATIONAL_AVG_DATA_RECEIVED = 'NATIONAL_AVG_DATA_RECEIVED';
export const GET_NATIONAL_DATA = 'GET_NATIONAL_DATA';
export const NATIONAL_DATA_RECEIVED = 'NATIONAL_DATA_RECEIVED';
export const GET_NATIONAL_PCT_DATA = 'GET_NATIONAL_PCT_DATA';
export const NATIONAL_PCT_DATA_RECEIVED = 'NATIONAL_DATA_PCT_RECEIVED';
export const GET_STATE_DATA = 'GET_STATE_DATA';
export const STATE_DATA_RECEIVED = 'STATE_DATA_RECEIVED';
export const GET_STATE_PCT_DATA = 'GET_STATE_PCT_DATA';
export const STATE_PCT_DATA_RECEIVED = 'STATE_DATA_PCT_RECEIVED';
export const GET_SEARCH_DATA = 'GET_SEARCH_DATA';
export const SEARCH_DATA_RECEIVED = 'SEARCH_DATA_RECEIVED';
export const GET_DIMENSION_DATA = 'GET_DIMENSION_DATA';
export const DIMENSION_DATA_RECEIVED = 'DIMENSION_DATA_RECEIVED';


// WEBPACK FOOTER //
// ./src/redux/actions/action-types.js